// extracted by mini-css-extract-plugin
module.exports = {"app":"index-module--app--yeV25"};